<div class="qo-spacing mt-4 md:mt-16 mb-6 text-center" responsive #responsive="responsive">
    <h1 class="font-display font-medium text-base sm:text-xl md:text-2xl mb-4 uppercase opacity-60" i18n>Recrutement</h1>
    <h2 class="font-title font-black text-4xl/tight sm:text-6xl/tight md:text-7xl/tight mb-4" i18n>Ensemble, on va plus loin !</h2>
</div>

<div class="qo-spacing mx-auto max-w-4xl text-center my-4">
    <p class="mb-8" i18n>Parce qu'il n'y a pas d'événement réussi sans une équipe adéquate, Qoezion réunit tous les ingrédients pour faire de votre recrutement les fondations de votre succès !</p>
</div>

<div class="qo-spacing-sm mb=y-12 md:mt-16 md:mb-56 max-w-screen-lg mx-auto">
    <iframe class="block aspect-bg-video shadow-screen" src="https://player.vimeo.com/video/665683409?background=1" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
</div>

<div class="qo-spacing max-w-2xl md:max-w-qo mx-auto md:grid md:gap-24 lg:gap-48 md:grid-cols-2 items-center my-16 md:my-56">
    <div class="">
        <h2 class="mb-8" i18n>Créez le formulaire qui vous ressemble.</h2>
        <p class="mb-8" i18n>Créez et personnalisez votre formulaire de candidature pour récolter les informations dont vous aurez besoin pour constituer votre communauté et coordonner votre future équipe : identité et coordonnées, disponibilités, compétences, documents, photos...</p>
    </div>

    <div class="relative">
        <div class="bg-qo-color1/60 absolute -bottom-6 top-6 left-8 w-1/2 rounded-3xl"></div>
        
        <picture>
            <source [srcset]="assetsPath + 'application-form.webp'" type="image/webp">
            <source [srcset]="assetsPath + 'application-form.png'" type="image/png">
            <img class="qo-img-crisp relative shadow-screen w-full rounded-xl max-w-595px" width="597" height="430" [src]="assetsPath + 'application-form.png'" alt="" loading="lazy"/> 
        </picture>
    </div>
</div>  

<div class="qo-spacing max-w-2xl md:max-w-qo mx-auto md:grid md:gap-24 lg:gap-48 md:grid-cols-2 items-center mt-20 mb-16 md:my-72">
    <div class="md:order-2">
        <h2 class="mb-8" i18n>Construisez votre équipe.</h2>
        <p class="mb-8" i18n>Diffusez facilement votre formulaire de candidature dans vos mailings, sur vos réseaux sociaux et sur votre site internet. Votre formulaire n’est pas encore prêt ? Vous pouvez permettre à vos équipiers de se préinscrire dès maintenant. Vous pouvez également inviter les membres de votre communauté à vous rejoindre.</p>

    </div>

    <div class="md:order-1">
        <picture>
            <source [srcset]="assetsPath + 'build-team.webp'" type="image/webp">
            <source [srcset]="assetsPath + 'build-team.png'" type="image/png">
            <img class="relative mx-auto" width="554" height="390" [src]="assetsPath + 'build-team.png'" alt="" loading="lazy"/>
        </picture>
    </div>
</div>  

<div class="qo-spacing max-w-2xl md:max-w-qo mx-auto md:grid md:gap-24 lg:gap-48 md:grid-cols-2 items-center my-16 md:my-72">
    <div class="">
        <h2 class="mb-8" i18n>Suivez la progression de votre recrutement.</h2>
        <p class="mb-8" i18n>Disposez instantanément d'une vision globale ou détaillée du profil de vos candidats et assurez-vous de composer l'équipe qui correspond à vos besoins : un effectif suffisant, disponible et disposant des compétences recherchées.</p>
    </div>

    <div class="relative mt-16 md:mt-0">
        <picture>
            <source [srcset]="assetsPath + 'contacts-list.webp'" type="image/webp">
            <source [srcset]="assetsPath + 'contacts-list.png'" type="image/png">
            <img class="qo-img-crisp relative shadow-screen w-full rounded-xl max-w-595px" width="597" height="430" [src]="assetsPath + 'contacts-list.png'" alt="" loading="lazy"/>      
        </picture>
        <picture>
            <source [srcset]="assetsPath + 'contact.webp'" type="image/webp">
            <source [srcset]="assetsPath + 'contact.png'" type="image/png">
            <img class="qo-img-crisp absolute -top-12 right-8 w-1/3 lg:w-[203px]" width="305" height="646" [src]="assetsPath + 'contact.png'" alt="" loading="lazy"/>
        </picture>

    </div>
</div>  

<div class="qo-spacing max-w-2xl md:max-w-qo mx-auto md:grid md:gap-24 lg:gap-48 md:grid-cols-2 items-center my-16 md:my-56">
    <div class="md:order-2">
        <h2 class="mb-8" i18n>Interagissez avec les candidats.</h2>
        <p class="mb-8" i18n>Parce qu'un événement c'est avant tout une aventure humaine, avec Qoezion, posez les fondations d'une collaboration durable en interagissant régulièrement avec vos équipes avec la messagerie, l'envoi de SMS ou encore le partage d'informations et de documents via l'espace personnel de chacun.</p>

    </div>

    <div class="md:order-1 relative">
        <div class="bg-qo-color3/60 absolute top-1/4 bottom-1/4 left-1/4 w-4/7 rounded-3xl"></div>
        <picture>
            <source [srcset]="assetsPath + 'chat.webp'" type="image/webp">
            <source [srcset]="assetsPath + 'chat.png'" type="image/png">
            <img class="qo-img-crisp relative shadow-screen w-auto sm:w-60 md:w-278px h-96 sm:h-auto mx-auto" width="278" height="603" [src]="assetsPath + 'chat.png'" alt="" loading="lazy"/>
        </picture>
        <img class="absolute top-4 left-1/2 -translate-x-1/2 w-88 sm:w-auto" width="514" height="504" [src]="assetsPath + 'chat-sms.svg'" alt="" loading="lazy" />
    </div>
</div>

<div class="qo-spacing-md mb-12 lg:mb-56">
    <qo-customer-story theme="qoezion"></qo-customer-story>
</div>

<div class="qo-spacing max-w-screen-md mx-auto my-16 sm:my-20">
    <h2 class="text-center mb-14" i18n><span class="block text-qo-qoezion dark:text-qo-qoezionDark">Vous aussi,</span>rejoignez les nombreux événements qui font confiance à Qoezion !</h2>

    <qo-try-and-book class="flex justify-center"></qo-try-and-book>
</div>

<qo-poster-list></qo-poster-list>